import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http} from '@angular/http';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MdInputModule } from '@angular/material';

// Layout
import { LayoutComponent } from './layout/layout.component';
import { PreloaderDirective } from './layout/preloader.directive';
// Header
import { AppHeaderComponent } from './layout/header/header.component';
// Sidenav
import { AppSidenavComponent } from './layout/sidenav/sidenav.component';
import { ToggleOffcanvasNavDirective } from './layout/sidenav/toggle-offcanvas-nav.directive';
import { AutoCloseMobileNavDirective } from './layout/sidenav/auto-close-mobile-nav.directive';
import { AppSidenavMenuComponent } from './layout/sidenav/sidenav-menu/sidenav-menu.component';
import { AccordionNavDirective } from './layout/sidenav/sidenav-menu/accordion-nav.directive';
import { AppendSubmenuIconDirective } from './layout/sidenav/sidenav-menu/append-submenu-icon.directive';
import { HighlightActiveItemsDirective } from './layout/sidenav/sidenav-menu/highlight-active-items.directive';
// Customizer
import { AppCustomizerComponent } from './layout/customizer/customizer.component';
import { ToggleQuickviewDirective } from './layout/customizer/toggle-quickview.directive';
//date range picker
import { Daterangepicker } from 'ng2-daterangepicker';
// Footer
import { AppFooterComponent } from './layout/footer/footer.component';
// Search Overaly
import { AppSearchOverlayComponent } from './layout/search-overlay/search-overlay.component';
import { SearchOverlayDirective } from './layout/search-overlay/search-overlay.directive';
import { OpenSearchOverlaylDirective } from './layout/search-overlay/open-search-overlay.directive';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService  } from './loader/loader.service';
import { CommonService } from './shared/services/common.service';
// Pages
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { ForgotPasswordComponent } from './forgot-password/forgotPassword.component';
import { UnlockAccountComponent } from './unlock-account/UnlockAccountComponent';
import { WPASSComponent } from './system-level-setting/wpass/wpass.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { PartnersDashboardComponent } from './partners-dashboard/partners-dashboard.component';
import { ApplicationsManagerDashboardComponent } from './applications-manager-dashboard/applications-manager-dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { PageLayoutFullscreenComponent } from './page-layouts/fullscreen/fullscreen.component';
import { DialogComponent, ShowApplicationsDialogComponent, SelectApplicationsDialogComponent } from './dialog/dialog.component';
import { WelcomeDialogComponent } from './dialog/dialog.component';
import { BuAssignmentDialogComponent } from './dialog/dialog.component';

import { DashboardActionDialogComponent } from './dialog/dialog.component';
import { ApplicationDashboardActionDialogComponent } from './dialog/dialog.component';
import { ApplicationRejectActionDialogComponent } from './dialog/dialog.component';
import { RegistrationDialogComponent } from './dialog/dialog.component';
import { ActiveInactiveDialogComponent } from './dialog/dialog.component';
import { EmailPasswordActionDialogComponent } from  './profile/profile.component';
import { EmailActionDialogComponent } from './viewRequest/view-request.component';
import { CSVErrorDialogComponent } from './dialog/dialog.component';
// Sub modules
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ApproveRejectRequestModule } from './approve-reject-request/approve-reject-request.module';
import { MultiApproveRejectRequestModule } from './multi-approve-reject/multi-approve-reject-request.module';
import { ActivateDeactivateModule } from './activate-deactivate-request/activate-deactivate-request.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { ToasterModule } from 'angular2-toaster';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { ViewRequestModule } from './viewRequest/view-request.module';
import { AdminManagementModule } from './system-level-setting/adminManagement/adminManagement.module';
import { ManagerAssignmentModule } from './system-level-setting/managerAssignment/managerAssignment.module';
import { UserModule } from './user/user.module';
import { RequestBusinessUnitModule } from "./user-operations/request-business-unit/request-business-unit.module";
import { CSVUploadModule } from  './file-upload/fileUpload.module';
import { MyDatePickerModule } from 'mydatepicker';
// hmr
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';
//Services
import { HttpService } from './shared/services/http.service';
import { SessionHandler } from './shared/services/session-handler.service';
import { ErrorHandler } from './shared/services/error-handler.service';
import { AdminDashboardResultService } from './adminDashboardResultService';
import { PartnersDashboardResultService } from './partnersDashboardResultService';
import { ApplicationsManagerDashboardResultService } from './applicationsManagerDashboardResultService';
import { AdminListDashboardResultService } from './system-level-setting/adminManagement/adminListDashboardResultService';
import { ApplicationListDashboardResultService } from "./system-level-setting/applicationManagement/applicationListDashboardResultService";
import { BusinessUnitListDashboardResultService } from './system-level-setting/businessUnitManagement/businessUnitDashboardResultService';
import { ManagerListDashboardResultService } from './system-level-setting/managerAssignment/managerListDashboardResultService';
import { FileUploadListDashboardResultService } from './file-upload/fileUploadListDashboardResultService';
import { BusinessUnitListForUserDashboardResultService } from './user-operations/request-business-unit/businessUnitForUserDashboardResultService';
//Directive
import { BlockCutCopyPasteDirective } from './shared/directive/blockCutCopyPaste.directive';
// multilingual
import { AutocompleteModule } from 'ng2-input-autocomplete';
import {TranslateModule,TranslateLoader,TranslateStaticLoader} from 'ng2-translate';
import {ApplicationManagementModule} from "./system-level-setting/applicationManagement/applicationManagement.module";

import { userActivityLogs} from '../app/user-activity-logs/user-activity.logs.component';
import{ TranslationMessagesComponent } from '../app/translation-messages/translation-messages.component'
import {UserActivityResultService} from '../app/user-activity-logs/user-activity-datatable/userActivityResultService';
import { TranslationEmailComponent } from '../app/translation-email/translation-email.component'
import { APPCONFIG } from './config';
//import { CKEditorModule } from 'ckeditor4-angular';
import { CKEditorModule } from 'ng2-ckeditor';
import { from } from 'rxjs/observable/from';


export function createTranslateLoader(http: Http) {
    //return new TranslateStaticLoader(http, './assets/i18n', '.json');
    return new TranslateStaticLoader(http, APPCONFIG.URL+APPCONFIG.translationUrl, '?v='+APPCONFIG.translationVersion);
}

@NgModule({ 
    imports: [
        ToasterModule,
        BrowserModule,
        HttpModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ApproveRejectRequestModule,
        MultiApproveRejectRequestModule,
        ActivateDeactivateModule,
        AngularMultiSelectModule,
        AutocompleteModule.forRoot(),
        MdInputModule,
        // Sub modules
        LayoutModule,
        SharedModule,
        NgxDatatableModule,
        Daterangepicker,
        ViewRequestModule,
        AdminManagementModule,
        ManagerAssignmentModule,
        ApplicationManagementModule,
        UserModule,
        RequestBusinessUnitModule,
        MyDatePickerModule,
        CSVUploadModule,
        CKEditorModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [Http]
        }) 
    ],
    declarations: [
        AppComponent, 
        // Layout
        LayoutComponent,
        PreloaderDirective,
        // Header
        AppHeaderComponent,

        // Sidenav
        AppSidenavComponent,
        ToggleOffcanvasNavDirective,
        AutoCloseMobileNavDirective,
        AppSidenavMenuComponent,
        AccordionNavDirective,
        AppendSubmenuIconDirective,
        HighlightActiveItemsDirective,
        // Customizer
        AppCustomizerComponent,
        ToggleQuickviewDirective,
        // Footer
        AppFooterComponent,
        // Search overlay
        AppSearchOverlayComponent,
        SearchOverlayDirective,
        OpenSearchOverlaylDirective,
        // Dashboard
        AdminDashboardComponent,
        userActivityLogs,
        TranslationMessagesComponent,
        TranslationEmailComponent,
        PartnersDashboardComponent,
        ApplicationsManagerDashboardComponent,
        // Profile
        ProfileComponent,
        // Pages
        LoginComponent,
        RegistrationComponent,
        ForgotPasswordComponent,
        UnlockAccountComponent,
        WPASSComponent,
        PageLayoutFullscreenComponent,
        LoaderComponent,
        DialogComponent,
        SelectApplicationsDialogComponent,
        WelcomeDialogComponent,
        BuAssignmentDialogComponent,
        RegistrationDialogComponent,
        DashboardActionDialogComponent,
        ApplicationDashboardActionDialogComponent,
        ApplicationRejectActionDialogComponent,
        ActiveInactiveDialogComponent,
        EmailPasswordActionDialogComponent,
        EmailActionDialogComponent,
        CSVErrorDialogComponent,
        ShowApplicationsDialogComponent,
        //Directives
        BlockCutCopyPasteDirective,
        
    ],
    providers:[LoaderService, HttpService, SessionHandler, ErrorHandler, CommonService, AdminDashboardResultService, PartnersDashboardResultService, ApplicationsManagerDashboardResultService,
        UserActivityResultService,  AdminListDashboardResultService, ApplicationListDashboardResultService, BusinessUnitListDashboardResultService, ManagerListDashboardResultService, FileUploadListDashboardResultService, BusinessUnitListForUserDashboardResultService],
    entryComponents: [DialogComponent,SelectApplicationsDialogComponent,ShowApplicationsDialogComponent,WelcomeDialogComponent,BuAssignmentDialogComponent,DashboardActionDialogComponent,ApplicationDashboardActionDialogComponent,ApplicationRejectActionDialogComponent,RegistrationDialogComponent,ActiveInactiveDialogComponent,EmailPasswordActionDialogComponent,EmailActionDialogComponent,CSVErrorDialogComponent],
    bootstrap: [AppComponent]
})

export class AppModule {
    constructor(public appRef: ApplicationRef) {
        // console.log = function(){};
        // console.error = function(){};
        // window.alert = function(){}
    }
    hmrOnInit(store) {
        console.log('HMR store', store);
    }
    hmrOnDestroy(store) {
        let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
        // recreate elements
        store.disposeOldHosts = createNewHosts(cmpLocation);
        // remove styles
        removeNgStyles();
    }
    hmrAfterDestroy(store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.module.ts